import { defineStore } from 'pinia';
import { useRefreshStore } from '@/common/composables/refreshStore';
import {
  useListProductionOrders,
  type ListProductionOrderResponse,
} from '../api/listProductionOrderApi';
import { useProductionOrderStore } from 'shared/productionOrders/stores/productionOrderStore';

export const useRefreshProductionOrderStore = defineStore('refresh-production-orders', () => {
  const listProductionOrderApi = useListProductionOrders();
  const store = useProductionOrderStore();

  return useRefreshStore<ListProductionOrderResponse>({
    fetchFromServer() {
      return listProductionOrderApi.execute();
    },

    mergeToStore(response) {
      store.clear();
      store.merge(response.productionOrders);
    },
  });
});
